import { createAsyncThunk } from "@reduxjs/toolkit";
import * as contactService from "../../services/contact.service"
import { toast } from "react-toastify";

export const getContact = createAsyncThunk("contact/getContact", async (params?: any) => {
    try {
        const response = await contactService.getContact(params);
        return response
    } catch (error) {
        return;
    }
});

export const addContact = createAsyncThunk("contact/addContact", async (payload: any) => {
    try {
        const response = await contactService.addContact(payload);
        toast.success("Contact added Successfully", { autoClose: 2000 });
        return response
    } catch (error) {
        toast.error(error as string, { autoClose: 3000 });
        throw error;
    }
});

export const getDetailContact = createAsyncThunk("contact/getDetailContact", async (id: string) => {
    try {
        const response = await contactService.getDetail(id);
        return response
    } catch (error) {
        return;
    }
});

export const updateContact = createAsyncThunk("contact/updateContact", async ({ id, payload }: { id: string; payload: any }) => {
    try {
        const response = await contactService.updateContact(id, payload);
        toast.success("User updated Successfully", { autoClose: 2000 });
        return response;
    } catch (error) {
        toast.error(error as string, { autoClose: 3000 });
        throw error;
    }
});

export const createContact = createAsyncThunk("contact/createContact", async ({ payload }: { payload: any }) => {
    try {
        const response = await contactService.addContact(payload);
        toast.success("User added Successfully", { autoClose: 2000 });
        return response;
    } catch (error) {
        toast.error(error as string, { autoClose: 3000 });
        throw error;
    }
});


export const deleteContact = createAsyncThunk("contact/deleteContact", async (id: string) => {
    try {
        const response = await contactService.deleteContact(id);
        toast.success("User deleted Successfully", { autoClose: 2000 });
        return response;
    } catch (error) {
        toast.error(error as string, { autoClose: 3000 });
        throw error;
    }
});

export const bulkImportContacts = createAsyncThunk("contact/bulkImportContacts", async (contacts: any[]) => {
    try {
        const response = await contactService.bulkImportContacts(contacts);
        return response;
    } catch (error) {
        throw error;
    }
});